import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { IPlandayUnitsMatchData } from '@fi-app/external-platform-integration/planday/planday';
import { PlandayService } from '@fi-app/external-platform-integration/planday/planday.service';
import { SaveChangesWarningService } from '@fi-shared/fi-shared-services/save-changes-warning.service';
import { FiValidatingFormDirective } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.directive';

@Component({
    selector: 'planday-units-matching',
    templateUrl: './planday-units-matching.component.html',
    styleUrls: ['./planday-units-matching.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'planday-units-matching' },
    standalone: false,
})
export class PlandayUnitsMatchingComponent implements OnInit {
    @Input() plandayUnitsMatchData: IPlandayUnitsMatchData;

    get departments() {
        return this.plandayUnitsMatchData.Departments;
    }

    get plandayUnitMatches() {
        return this.plandayUnitsMatchData.PlandayUnitMatches;
    }

    @ViewChild(FiValidatingFormDirective, { static: true }) plandayUnitsMatchingForm: FiValidatingFormDirective;

    constructor(
        private plandayService: PlandayService,
        private saveChangesWarningService: SaveChangesWarningService,
    ) {}

    ngOnInit(): void {
        this.saveChangesWarningService.start(() => this.plandayUnitMatches);
    }

    onUnitsMatchingChanged() {
        this.plandayUnitsMatchingForm.updateValidity();
    }

    savePlandayUnitMatches() {
        this.saveChangesWarningService.stop();
        this.plandayService.savePlandayUnitMatches(this.plandayUnitMatches).then(() => {
            this.saveChangesWarningService.start(() => this.plandayUnitMatches);
        });
    }

    canSavePlandayUnitMatches() {
        return !this.plandayUnitsMatchingForm.errors;
    }
}
